/**
 * tailwind plugins was written using extend configuration feature. It was used to give our modal sizes into the existing config.

 * ? https://tailwindcss.com/docs/plugins#extending-the-configuration
 */
import plugin from 'tailwindcss/plugin'

export default plugin(
  function viewportHeightPlugin({ matchUtilities, theme }) {
    matchUtilities(
      {
        'h-screen': (value) => ({
          height: value,
        }),
      },
      { values: theme('hScreen') },
    )
  },
  {
    theme: {
      hScreen: {
        0: '0vh',
        25: '25vh',
        50: '50vh',
        60: '60vh',
        75: '75vh',
        'dashboard-layout': 'calc(100vh - 4rem)',
        // If this size not enough, you can add more size here
        'document-layout': 'calc(100vh - 4rem)',
      },
    },
  },
)
